import { render, staticRenderFns } from "./addCityArea.vue?vue&type=template&id=9b40f2b8"
import script from "./addCityArea.vue?vue&type=script&lang=js"
export * from "./addCityArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports